import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Cases from "../pages/cases/page";
import CaseDetail from "../pages/cases/detail";
import Contact from "../pages/contact/page";
import Process from "../pages/process/page";
import Faq from "../pages/faq/page";
import Insights from "../pages/insights/page";
import InsightDetail from "../pages/insights/detail";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/cases/:id",
    element: <CaseDetail />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/process",
    element: <Process />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/insights",
    element: <Insights />,
  },
  {
    path: "/insights/:id",
    element: <InsightDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
